import React, { useState, useEffect } from "react";

const Contact = ({ data, onSubmit, onCancel }) => {

  const [address, setAddress] = useState({
    title: "",
    address1: "",
    address2: "",
    address3: "",
    contact_no: "",
    email: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    if (data) {
      setAddress(data);
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!address.title.trim()) {
      setError("Contact Type is required.");
      return;
    }
    setError("");
    onSubmit(address);
  };

  return (
    <div>
      <h3>{data?.id ? "Edit Address" : "Create Address"}</h3>
      <form onSubmit={handleSubmit} className="mt-4">
        <div className="form-group">
          <label>Contact Type</label>
          <input
            type="text"
            className="form-control"
            name="title"
            value={address.title}
            onChange={handleChange}
            placeholder="Enter contact type"
          />
          {error && <small className="text-danger">{error}</small>}
        </div>
        <div className="form-group">
          <label>Address1</label>
          <input
            type="text"
            className="form-control"
            name="address1"
            value={address.address1}
            onChange={handleChange}
            placeholder="Enter address 1"
          />
        </div>
        <div className="form-group">
          <label>Address2</label>
          <input
            type="text"
            className="form-control"
            name="address2"
            value={address.address2}
            onChange={handleChange}
            placeholder="Enter address 2"
          />
        </div>
        <div className="form-group">
          <label>Address3</label>
          <input
            type="text"
            className="form-control"
            name="address3"
            value={address.address3}
            onChange={handleChange}
            placeholder="Enter address 3"
          />
        </div>
        <div className="form-group">
          <label>Mobile No</label>
          <input
            type="number"
            className="form-control"
            name="contact_no"
            value={address.contact_no}
            onChange={handleChange}
            placeholder="Enter Mobile No"
          />
        </div>
        <div className="form-group">
          <label>Emailid</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={address.email}
            onChange={handleChange}
            placeholder="Enter Email Address"
          />
        </div>
        <div className="mt-3">
          <button type="submit" className="btn btn-success mr-2">
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Contact;
